import React from 'react';

import { cn } from 'lib/utils';

/**
 * Presentational card used for result items (racing, baseball, football).
 * Matches football3d week board card style: rounded-xl, bg-card, shadow-sm.
 */
export default function ResultCard(props: {
  children: React.ReactNode;
  className?: string;
  /** Optional data attribute for tests/analytics */
  'data-event-results-market'?: string;
}) {
  const { children, className, 'data-event-results-market': dataMarket } = props;
  return (
    <div
      className={cn(
        'rounded-lg border border-border bg-card text-card-foreground p-2 shadow-sm',
        className
      )}
      {...(dataMarket != null ? { 'data-event-results-market': dataMarket } : {})}
    >
      {children}
    </div>
  );
}
